"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MciReportsType = void 0;
var MciReportsType;
(function (MciReportsType) {
    MciReportsType["Conversions"] = "mci-conversions-reports";
    MciReportsType["Offers"] = "mci-reports";
    MciReportsType["Rejections"] = "mci-rejections-reports";
})(MciReportsType || (exports.MciReportsType = MciReportsType = {}));
